module.exports = __webpack_public_path__ + "media/images/icons/calendar-11386a6cbf921e3a6a32d865f4e27341.svg";